import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "save",
  "use": "save-usage",
  "viewBox": "0 0 15 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 18\" id=\"save\">\n    <path fill=\"none\" fill-rule=\"evenodd\" stroke=\"#4A4A4A\" stroke-width=\"2\" d=\"M1 1v14.932l6.5-5.149 6.5 5.15V1H1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol